import { useMemo } from 'react';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { MaximumTileTextLength } from '../atom.tile/context.js';
import { FacitContainer } from './organism.facit-container.js';
import { InputContainer } from './organism.input-container.js';
import { jsx } from 'react/jsx-runtime';

function PlaceItemsInTextTask(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  const content = (() => {
    if (context === "input" && pageContext !== "print") {
      return /*#__PURE__*/jsx(InputContainer, {
        ...props
      });
    } else {
      return /*#__PURE__*/jsx(FacitContainer, {
        ...props
      });
    }
  })();
  const maximumTileTextLength = useMemo(() => props.task.tiles.reduce((acc, curr) => {
    switch (curr.type) {
      case "Audio":
        return Math.max(acc, curr.title.length);
      case "Image":
        return Math.max(acc, curr.title.length);
      case "Text":
        return Math.max(acc, curr.text.length);
    }
  }, 0), [props.task.tiles]);
  return /*#__PURE__*/jsx(MaximumTileTextLength.Provider, {
    value: maximumTileTextLength,
    children: content
  });
}

export { PlaceItemsInTextTask };
//# sourceMappingURL=_task.in-text.js.map
